export type PriceSource = number | { price?: number | null } | null

type Price = number | string | null | undefined

function getPriceByComparator(
  price: Price,
  prices: PriceSource[] | null | undefined,
  comparator: (...values: number[]) => number
): number {
  // Gather and normalize all candidate prices (array and single price)
  const candidates = [
    ...(prices ?? []).map((p) =>
      typeof p === 'object' && p !== null && 'price' in p ? p.price : p
    ),
    price
  ]
    .map((p) => {
      let value: number | undefined
      if (typeof p === 'number') {
        value = p
      } else if (typeof p === 'string') {
        value = parseFloat(p)
      } else {
        value = undefined
      }
      return value
    })
    .filter((v): v is number => v != null && !isNaN(v))

  return candidates.length > 0 ? comparator(...candidates) : 0
}

export function getMinimumPrice(
  price: number | string | null | undefined,
  prices: PriceSource[] | null | undefined
): number {
  return getPriceByComparator(price, prices, Math.min)
}

export function getMaximumPrice(
  price: number | string | null | undefined,
  prices: PriceSource[] | null | undefined
): number {
  return getPriceByComparator(price, prices, Math.max)
}

export function hasSizeBasedPricing(
  prices: PriceSource[] | null | undefined
): boolean {
  return !!prices && prices.length > 1
}
